module.exports = __webpack_public_path__ + "static/media/16-min.172ad3e3.jpg";